import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import StepHeader from '../../step-header';
import type { LogoConfig } from '../identify.types';
import type { HeaderProps } from '../types';
const getHeader = (logoConfig?: LogoConfig, onPrev?: () => void): ((props: HeaderProps) => JSX.Element) => {
  const CLOSE = {
    variant: 'close'
  } as const;
  const BACK = {
    variant: 'back',
    onBack: onPrev
  } as const;
  const leftButton = onPrev ? BACK : CLOSE;
  const Header = t0 => {
    const $ = _c(4);
    const {
      title,
      subtitle,
      overrideLeftButton
    } = t0;
    const t1 = overrideLeftButton || leftButton;
    let t2;
    if ($[0] !== subtitle || $[1] !== t1 || $[2] !== title) {
      t2 = <StepHeader leftButton={t1} logoUrl={logoConfig?.logoUrl} orgName={logoConfig?.orgName} showLogo={!!logoConfig} subtitle={subtitle} title={title} />;
      $[0] = subtitle;
      $[1] = t1;
      $[2] = title;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  };
  return Header;
};
export default getHeader;